import PropTypes from 'prop-types'
import React from 'react'
import useProductPricing from '../../hooks/use-product-pricing'
import DisplayPrice from '../display-price'
import {useCommerceData} from '../../hooks/use-commerce-data'

const ProductDisplayPrice = ({
    as: Component = DisplayPrice,
    product,
    isBonusProduct,
    showVatLabel,
    variant,
    size,
    alignment,
    loading
}) => {
    const {isEcommerceEnabled, showPricesOnContentOnly} = useCommerceData(product)

    const {price, displayPrice, hasDiscount, isFree} =
        useProductPricing(product, isBonusProduct) || {}

    // site based attribute to hide all promo signals (strike-through price, savings label)
    // while keeping the calculated price. See STOK-17150.
    const hidePromotionSignals = Boolean(product?.c_hidePromotionSignals)

    // content only sites do not render prices
    if (!isEcommerceEnabled && !showPricesOnContentOnly) {
        return null
    }

    return (
        <Component
            price={price}
            displayPrice={displayPrice}
            hasDiscount={hasDiscount}
            hidePromotionSignals={hidePromotionSignals}
            isFree={isFree}
            loading={loading}
            showVatLabel={showVatLabel}
            variant={variant}
            size={size}
            alignment={alignment}
            currency={product?.currency}
        />
    )
}

ProductDisplayPrice.propTypes = {
    as: PropTypes.elementType,
    product: PropTypes.object,
    isBonusProduct: PropTypes.bool,
    loading: PropTypes.bool,
    showVatLabel: PropTypes.bool,
    variant: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md']), PropTypes.object]),
    alignment: PropTypes.oneOf(['start', 'center', 'end'])
}

export default ProductDisplayPrice
